module.exports = __webpack_public_path__ + "static/media/builtinv2-Option 1.37dc206a.png";